module.exports = __webpack_public_path__ + "static/christian-course-image-21c4466169112592e543c0f6669ac704.jpg";